import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import Navbar from "../../components/navbar/Navbar";
import styles from "./CampaignDetail.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { endpoints } from "../../../api/endpoints";
import { getFetcher, postFetcher } from "../../../api/fetchers";
import { useEffect, useState } from "react";
import { useUser } from "../../context/UserContext";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../../components/spinner/Spinner";
import { useLanguage } from "../../context/LanguageContext";

const CampaignDetail = () => {
  const { t } = useLanguage();
  const { id } = useParams();
  const [campaignDetail, setCampaignDetail] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useUser();
  const [isCheck, setIsCheck] = useState(false);

  const navigate = useNavigate();

  // fetch campaign detail
  useEffect(() => {
    const fetchCampaignDetail = async () => {
      setIsLoading(true);
      try {
        const response = await getFetcher(
          endpoints.campaigns.getCompanyCampaignsDetail.replace(
            "{id}",
            id || ""
          )
        );
        if (response.result) {
          setCampaignDetail(response.companyCampaign);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 200);
      }
    };

    fetchCampaignDetail();
  }, [id]);

  // the user added to the campaign
  const handleClickSubsFn = async () => {
    if (user) {
      try {
        const response = await postFetcher(
          endpoints.campaigns.addAUserToCompanyCampaign,
          {
            arg: {
              companyCampaignId: id,
              userId: user.id,
            },
          }
        );
        if (response.result) {
          setIsCheck(true);
          return toast.success(
            response.message ? response.message : t("toastMessage", "campSuc")
          );
        } else {
          setIsCheck(true);
          return toast.info(t("toastMessage", "campExist"));
        }
      } catch (error) {
        console.log(error);
        toast.error(t("toastMessage", "campErr"));
        setIsCheck(false);
      }
    }
  };

  // loading spinner
  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <Navbar />
        <main className="flex-grow flex justify-center items-center">
          <Spinner />
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <main className="flex flex-grow flex-col min-h-screen">
      {/* <Header />
      <Navbar /> */}

      <h1
        id="title"
        className={`text-center text-4xl text-primary-color my-16 ${styles.title}`}
      >
        Kampanya Detayları
      </h1>

      <div className="w-3/4 mx-auto mb-4 bg-gray-50">
        <ToastContainer position="top-right" />
        <img
          src={campaignDetail?.image}
          alt="Campaign Image"
          className=" object-cover h-[600px] w-1/2 mx-auto rounded-xl shadow-xl my-2 bg-white transform hover:scale-95 transition-all"
        />
        {/*Geri sayım kısmı ve Buton*/}
        <div className="flex flex-col md:justify-between items-center md:flex-row mt-6 ">
          <div>
            <p className="text-primary-color md:ml-20 md:w-3/5 flex self-center w-full ">
              {campaignDetail?.title} 🎁💐🥳
            </p>
          </div>
          <div className="md:w-2/5 w-full flex md:justify-end justify-center md:mr-20">
            {isCheck ? (
              <button
                onClick={() =>
                  navigate(`/product-detail/${campaignDetail.productId}`)
                }
                className="text-2xl mt-5 mb-5 bg-primary-color hover:bg-color-gray text-white hover:border-2 hover:border-primary-color hover:text-primary-color py-2 px-12 rounded-md"
              >
                İncele
              </button>
            ) : (
              <button
                onClick={handleClickSubsFn}
                className="text-2xl mt-5 mb-5 bg-primary-color hover:bg-color-gray text-white hover:border-2 hover:border-primary-color hover:text-primary-color py-2 px-12 rounded-md"
              >
                Katıl
              </button>
            )}
          </div>
        </div>

        <h1 id="title" className="text-center text-2xl my-16">
          Kampanya Koşulları
        </h1>

        <div className="space-y-4 list-disc text-gray-400 mb-10 ml-10 md:ml-20">
          {campaignDetail?.description}
        </div>
      </div>

      {/* <Footer /> */}
    </main>
  );
};

export default CampaignDetail;
